import React from 'react';

/**
 * Compact top-bar CTA button shown after the promo is dismissed.
 * On desktop: renders top-left (by placement in HomeTopBar).
 * On mobile: becomes a full-width row below points + coins (via CSS order rules).
 */
const InviteFriendsButton = ({ onClick, className = '' }) => {
  return (
    <button
      className={`home-topbar-pill topbar-invite topbar-invite-btn ${className}`.trim()}
      onClick={onClick}
    >
      <span className="topbar-pill-emoji" role="img" aria-hidden="true">🎁</span>
      <span>Invite Friends (Earn 500)</span>
    </button>
  );
};

export default InviteFriendsButton;

